import React from 'react'
import { LegacyIcons } from 'components/elements/Icon'

import { ManaFontIcons } from 'components/misc/customIcons/ManaFont'
import { CustomIcons } from 'components/elements/CustomIcon'

export type Option = (
  | { type?: 'option' }
  | { type: 'spacer' }
  | { type: 'header' }
  | { type: 'message' }
  | { type: 'checkbox'; checked: boolean; onChange: () => void }
  | { type: 'custom'; customChild: React.ReactNode; onAccessibleClick?: () => void }
  | { type: 'extras'; id: string; options: Option[]; extraTriggerClassName?: string }
) & {
  to?: string
  ariaLabel?: string
  rel?: string
  target?: string
  icon?: LegacyIcons
  manaFontIcon?: ManaFontIcons
  customIcon?: CustomIcons
  hidden?: boolean
  onClick?: () => void
  noCloseOnClick?: boolean
  disabled?: boolean
  keybind?: string
  className?: string
  id?: string
  label?: React.ReactNode
}

export type TabIndexedOption = Option & { tabIndex?: number; id?: string }

export type DropdownProps = {
  children?: React.ReactNode
  triggerClassName?: string
  triggerIcon?: LegacyIcons
  defaultTriggerClassName?: string
  menuClassName?: string
  triggerStyle?: React.CSSProperties
  menuStyle?: React.CSSProperties
  direction?: 'up' | 'down'
  disabled?: boolean
  noShowWithoutOptions?: boolean
  tabIndex?: number
  skipCloseOnClick?: boolean
  focusedOnMount?: boolean
  onFocus?: () => void
  onBlur?: () => void
  options?: Option[]
  customOptionsTop?: React.ReactNode
  customOptionsBottom?: React.ReactNode
}

export const groupOptions = (accumulator: Option[][], option: Option, index: number) => {
  if (!option) return accumulator

  if (!accumulator.length) accumulator.push([]) // Setup

  const lastGroupIndex = accumulator.length - 1

  // If option is a header, push the header as it's own group, and push a new group to follow
  if (option.type === 'header') {
    accumulator.push([option])
    accumulator.push([])

    return accumulator
  }

  if (option.type === 'spacer' && !option.hidden) accumulator.push([])
  else if (!option.hidden) accumulator[lastGroupIndex].push(option)

  return accumulator
}
